import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['parent']

  static values = {
    parentClassName: 'parent__loading-spinner',
    partial: String,
  };

  spin () {
    this.parentTarget.classList.add(this.parentClassNameValue);
    this.parentTarget.insertAdjacentHTML('beforeend', `${this.partialValue}`);
  }
}
